import { isFinanceProject } from 'config';
import { OrganizationalAndLegalForm } from 'modules/onboarding/legal/components';

import { useOrganizationalAndLegalForm } from '../hooks';
import { useOnboardingContext } from '../hooks/useOnboardingContext';
import { PageComponentProps } from '../types';

export const OrganizationalAndLegalFormStep = ({
  canGoBack,
}: PageComponentProps) => {
  const { goToBack, initialValues, onSubmit, submitLoading } =
    useOrganizationalAndLegalForm();

  const { step } = useOnboardingContext();

  return (
    <OrganizationalAndLegalForm
      canGoBack={canGoBack}
      enabledOrganizationType={isFinanceProject()}
      initialValues={initialValues}
      step={step}
      submitLoading={submitLoading}
      onGoBack={goToBack}
      onSubmit={onSubmit}
    />
  );
};
